const JSON_BLOCK_REGEX = /```(?:json)?\s*([\s\S]*?)\s*```/gi;

const FALLBACK_MESSAGE = '요청하신 결과를 정리했어요. 화면에서 확인해 주세요.';

function isJsonPayload(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed) return false;
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return false;

  try {
    const parsed = JSON.parse(trimmed) as unknown;
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }
}

function containsJsonBlock(text: string): boolean {
  let match: RegExpExecArray | null = null;

  while ((match = JSON_BLOCK_REGEX.exec(text)) !== null) {
    const block = match[1]?.trim() ?? '';
    if (isJsonPayload(block)) return true;
  }

  return false;
}

export function sanitizeAssistantContent(content: string): string {
  const trimmed = content.trim();
  if (!trimmed) return content;

  if (isJsonPayload(trimmed) || containsJsonBlock(content)) {
    return FALLBACK_MESSAGE;
  }

  return content;
}
